import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * DuplicateActionPath
 *
 * Duplicates a single action path from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const DuplicateActionPath = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {
        actionPathName: thePayload?.name,
      },
      headers: {
        'x-api-endpoint': `/action-paths/${thePayload?.id}/duplicate`,
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/ActionPath/api/requests/mutations/DuplicateActionPath.js -> DuplicateActionPath()',
      false,
      error
    );

    throw error;
  }
};
